module.exports = __webpack_public_path__ + "static/media/1n.6f0a6bfa.jpg";